import store from '@/store'
import { ROLES } from '@/config/permissions'

/**
 * Vérifie si l'utilisateur possède les permissions demandées.
 *
 * @param {string[]} value - Permissions à vérifier
 * @param {Object} [options]
 * @param {'any'|'all'} [options.mode='any'] - 'any' = au moins une (OR), 'all' = toutes (AND)
 * @returns {boolean}
 *
 * @example
 *   // OR (défaut) — au moins une permission
 *   $checkPerms([P.COMPTES.BROWSE])
 *
 *   // AND — toutes les permissions requises
 *   $checkPerms([P.COMPTES.EDIT, P.COMPTES.BROWSE], { mode: 'all' })
 */
export const checkPerms = (value, { mode = 'any' } = {}) => {
  if (!Array.isArray(value) || value.length === 0) {
    console.warn('checkPerms: expected non-empty array of permissions')
    return false
  }

  const perms = store.getters?.permissions || []
  const roles = store.getters?.roles || []

  // Super admin bypass
  if (roles.includes(ROLES.SUPER_ADMIN)) return true

  const checker = mode === 'all' ? 'every' : 'some'
  return value[checker](p => perms.includes(p))
}
